// extracted by mini-css-extract-plugin
export default {"headerText":"ClickAnalysisCard_headerText__VCf6n"};